import dayjs from 'dayjs'
import { qcopy, findObjIndexInArray, padZero, trimEndZero } from '@u'
import { derrorFactory, errorFactory } from '@u/log'
import { _basalRateBaseSettingInfosFromValueArray, _getDeadlineGaps, _otherDataGetTimeZoneFilter, _otherDataGetPumpClockFilter } from '@u/reportHelperPump'
// import { _getMergedPumpBigDosageFromRecords, _getPumpBigDosageFromRecords } from '@u/reportHelper'
import { _groupArrays, _f1, _f2, _f3, _f4, _f5, _f6, _f7 } from './pumpExclusiveMixinUtil'
import { _getUTCOffset } from '@u/timezoneDict'

const derror = derrorFactory('pumpExclusiveMixin', false)
const error = errorFactory('pumpExclusiveMixin', false)

const _notZeroVHolder = 0.000000000000000000000001
export default {
  data() {
    return {
      beforeData: {},
      afterData: {},
      alarmRecordRowNumsMax: 11, // 一页最多放$alarmRecordRowNumsMax行,实际中一页高度差不多能放22行
      basalRateBaseSettingRowsMax: 12,
      pumpSnList: [],
      otherData: [],
      pumpLegalDailyList: [],
      sevenDayReadingsInTarget: [],
      calculatorList: [],
      warmMsg: [],
      basalRateInfoMsg: [],
      quickPumpTagList: [], // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      basalRateBaseSetting: [],
      pdaSetting: {},
      dataUploadHis: [] // 服务端返回的是无序的
    }
  },
  methods: {
    helperOneDayUploadDataEvent(value) {
      const { dataUploadHis = [] } = this
      const { date } = value
      const dateUploads = dataUploadHis.filter(obj => {
        const fmt = 'YYYY-MM-DD'
        return dayjs(date).format(fmt) === dayjs(obj.uploadTimeStr).format(fmt)
      })
      
      return dateUploads
    },
    helperGetYesterdayOtherData(arr = [], _date, getYesterday = false) {
      let date = _date
      if (getYesterday) {
        date = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
      }
      const rst = arr.find(obj => obj && obj.date === date) || {}
      return rst
    },
    timeChangeRecordConstructTableDataHelper(timeChanges = []) {
      return timeChanges.map(record => {
        if (!record) return ''
        const beforeY = record.statusShort1
        const beforeDate = record.statusShort0
        const l = `${beforeDate}`.length
        const beforeDay = `${beforeDate}`.substr(-2)
        const beforeMonth = `${beforeDate}`.substr(0, l - 2)
        const beforeHour = record.statusByte1
        const beforeMinute = record.statusByte0
        const before = `${beforeY}-${padZero(beforeMonth)}-${beforeDay} ${padZero(beforeHour)}:${padZero(beforeMinute)}`
        const after = dayjs(record.dateTimeStr).format('YYYY-MM-DD HH:mm')
        
        return {
          column0: before,
          column1: after
        }
      })
    },
    moduleLegendsHelper(value = {}) {
      const { sortedBasalRateBaseSetting = [] } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const changeRecords = (otherData.filter(v => v && +v.eventType === 3)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const changes = changeRecords.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)
      
      if (!changes.length) {
        return []
      }
      
      const nameLengthMax = 12 // 名字最长12字符
      
      const rst = changes.map((change, i) => {
        const order = i + 1 // 第order次
        
        const fromI = +change.statusByte1 // 7为原来没有基础率
        const baseI = fromI > 6 ? -1 : findObjIndexInArray(sortedBasalRateBaseSetting, fromI, 'settingIndex')
        const from = baseI >= 0 ? _legalLengthName(sortedBasalRateBaseSetting[baseI]['settingName']) : undefined
        
        const toI = +change.statusByte0 // 7为原来没有基础率
        const baseI2 = toI > 6 ? -1 : findObjIndexInArray(sortedBasalRateBaseSetting, toI, 'settingIndex')
        const to = baseI2 >= 0 ? _legalLengthName(sortedBasalRateBaseSetting[baseI2]['settingName']) : undefined
        
        return {
          order, to, from
        }
      })
      
      rst.splice(5) // 最多5条
      return rst
      
      function _legalLengthName(name = '') {
        const l = name.length
        if (l >= nameLengthMax) {
          return name.substring(0, nameLengthMax - 1)
        } else {
          return name
        }
      }
    },
    uiDataHelperGetTwoColumnFromAlarmRecords(list = []) {
      const fmt = 'HH:mm'
      const rst = list.map(record => {
        const isTimeChangeEvent = record && record.isTimeChangeRecord === true
        
        if (isTimeChangeEvent) {
          const v = record
          const { eventType, isTimeZoneChangeRecord } = v
          const fmt = 'MM/DD HH:mm'
          if (isTimeZoneChangeRecord) {
            // 改时区
            const beforeTZIndex = v.statusByte1
            const afterTZIndex = v.statusByte0
            const beforeTZOffset = _getUTCOffset(beforeTZIndex)
            const afterTZOffset = _getUTCOffset(afterTZIndex)
            derror(`beforeTZOffset: ${beforeTZOffset}, afterTZOffset: ${afterTZOffset}`)
            const before = `${this.$t('UTC')}${beforeTZOffset >= 0 ? '+' : ''}${beforeTZOffset}`
            const after = `${this.$t('UTC')}${afterTZOffset >= 0 ? '+' : ''}${afterTZOffset}`
            
            return {
              column0: before,
              column1: after
            }
          } else {
            // 改时间
            const beforeHour = v.statusByte1
            const beforeMinute = v.statusByte0
            const beforeMD = `${v.statusShort0}`
            const beforeDay = beforeMD.substr(-2)
            const beforeMonth = beforeMD.substr(0, beforeMD.length - 2)
            const before = `${padZero(beforeMonth)}/${beforeDay} ${padZero(beforeHour)}:${padZero(beforeMinute)}`
            // const after = dayjs(v.dateTimeStr).format(fmt)
            const after = dayjs(v.dateTime).format('MM/DD HH:mm')
            
            return {
              column0: before,
              column1: after
            }
          }
        } else { // 报警事件
          return { column0: dayjs(record.dateTimeStr).format(fmt), column1: this.$t(record.remark) } 
        }
      })
      // derror(`uiDataHelperGetTwoColumnFromAlarmRecords, list`, list)
      // derror(`uiDataHelperGetTwoColumnFromAlarmRecords, rst`, rst)
      return rst
    },
    helperGetDailyMesurement(data = {}) {
      const { threeChartData = {}} = data
      const { NumberOfBgMeasurements, insulinChart } = threeChartData      
      const rst = {
        ...NumberOfBgMeasurements
      }

      // 增加每日的insulinChart信息
      let insulinBasal
      let insulinBolus
      let insulinTotal

      if (insulinChart && insulinChart.totalBasal !== undefined) {
        Object.assign(rst, {
          insulinBasal: insulinChart.totalBasal,
          insulinBolus: insulinChart.totalBolus,
          insulinTotal: trimEndZero((+insulinChart.totalBasal + +insulinChart.totalBolus).toFixed(3))
        })
      }
      
      return rst
    },
  },
  computed: {
    allDailyListWithFake() { // 包含自定义的数据(前一天和后一天)
      const { beforeData, afterData, dailyList = [] } = this
      const first = dailyList[0]
      const last = dailyList[dailyList.length - 1]
      if (!first || !last) {
        return []
      }
      const fdate = first.date
      const ldate = last.date

      const tmp0 = qcopy(beforeData)
      delete tmp0.pumps
      const tmp1 = qcopy(afterData)
      delete tmp1.pumps
      
      const before = {
        date: dayjs(fdate).subtract(1, 'day').format('YYYY-MM-DD'),
        ...tmp0,
        threeChartData: {
          insulinChart: {
            list: qcopy(beforeData.pumps)
          }
        }
      }
      const after = {
        date: dayjs(ldate).add(1, 'day').format('YYYY-MM-DD'),
        ...tmp1,
        threeChartData: {
          insulinChart: {
            list: qcopy(afterData.pumps)
          }
        }
      }

      return [before, ...(dailyList.slice()), after].filter(r => r)
    },
    allDailyList() {
      const { dailyList = [] } = this
      return dailyList
    },
    allPumpRecords() { // 包含时间范围前后n天的数据,关键用来获取死线gaps(_getDeadlineGaps)
      const { beforeData = {}, afterData = {}, _bgnTime: bgnTime, _endTime: endTime, multiDay = {}} = this
      const { insulinChart = {}} = multiDay
      const { list = [] } = insulinChart
      const bpumps = beforeData.pumps || []
      const apumps = afterData.pumps || []

      /* ++++++++++前后都分别增加一个非零的基础率记录。值是如此小，以至于最后渲染的charts上肉眼不可见。但同时，死线又能画到此处++++++++++ */
      const fmt = 'YYYY-MM-DD HH:mm:ss'
      const $now = dayjs()
      const nowT = +$now
      const startLimitT = +dayjs(bgnTime).startOf('day').subtract(1, 'day') + 1 // 目前服务端只返回选取的时间范围的前后一天。等以后返回更多了，这边的逻辑也可以相应更改
      const endLimitT = +dayjs(endTime).endOf('day').add(1, 'day') - 1 // 目前服务端只返回选取的时间范围的前后一天。等以后返回更多了，这边的逻辑也可以相应更改
      const endPointT = Math.min(nowT, endLimitT)
      const _fakeRecord = {
        basalRate: _notZeroVHolder,
        battery: null,
        bolusRate: 0,
        dataType: null,
        dateTimeStr: '',
        dbDataTime: '',
        delayTime: 0,
        deviceRecordTime: '',
        index: 0,
        port: '5',
        recordTimeZone: 'Asia/Shanghai',
        reservoir: null,
        totalBasal: 0,
        totalBolus: 0,
        type: '4',
        urgency: '0',
        value: '0',
        isFake: true // 用来占位，从而能让跨天死线能正确判断并正确绘画
      }
      const startRecord = Object.assign({}, _fakeRecord, { dateTimeStr: dayjs(startLimitT).format(fmt) })
      const endRecord = Object.assign({}, _fakeRecord, { dateTimeStr: dayjs(endPointT).format(fmt) })
      /* ++++++++++End of 前后都分别增加一个非零的基础率记录。值是如此小，以至于最后渲染的charts上肉眼不可见。但同时，死线又能画到此处++++++++++ */

      return [startRecord, ...bpumps, ...list, ...apumps, endRecord]
    },
    allBasalRateInfoMsges() { // 包含时间范围前后n天的数据
      const { beforeData = {}, afterData = {}, basalRateInfoMsg = [] } = this
      const list = basalRateInfoMsg || []
      const bmsgs = beforeData.basalRateInfoMsg || []
      const amsgs = afterData.basalRateInfoMsg || []
      return [...bmsgs, ...list, ...amsgs]
    },
    allDeadlineGaps() {
      const { allPumpRecords, allBasalRateInfoMsges } = this      
      const rst = _getDeadlineGaps(allPumpRecords, allBasalRateInfoMsges)
      derror(`allDeadlineGaps: `, rst.map(([s, e]) => [dayjs(s).format('YYYY-MM-DD HH:mm:ss'), dayjs(e).format('YYYY-MM-DD HH:mm:ss')]))
      return rst
    },
    reverseCorrection() {
      const { otherData = [] } = this
      const type5s = otherData.filter(v => +v.eventType === 5)
      const ordered = type5s.sort((f, s) => dayjs(s.dateTimeStr) - dayjs(f.dateTimeStr)) // 倒序，dateTimeStr约大的在数组第一个
      if (ordered && ordered.length) {
        const r = ordered[0]
        const chosed = `${r.statusByte1}` === '1' // 1是勾选;0是不勾选
        return chosed
      } else {
        return ''
      }
    },
    timeChangeRecordList() {
      const { otherData = [] } = this
      const timeChanges = otherData.filter(_otherDataGetPumpClockFilter) // 1: 修改日期或时间;2: 修改时区(目前说是这种record是不会有的)
      // const timeChanges = otherData.filter(_otherDataGetTimeChangeFilter) // 1: 修改日期或时间
      // return timeChanges((first, second) => first.settingIndex - second.settingIndex) // 升序, settingIndex小的在数组前面
      return timeChanges
    },
    multiDayPumpGraphPages() {
      const { allDailyListWithFake = [], allDailyList = [], sevenDayReadingsInTarget = [] } = this
      let arr = allDailyList.map(obj => {
        const date = obj.date
        const yesterdayDate = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
        obj.yesterday = this.helperGetYesterdayOtherData(allDailyListWithFake, yesterdayDate)
        return obj
      })
      // let arr = allDailyList.slice()
      const onePageNum = 7
      const pagesNum = Math.ceil(allDailyList.length / 7)
      
      const pages = []
      
      let rest = arr
      for (let i = 0; i < pagesNum; i++) {
        const readingsInTargetChart = sevenDayReadingsInTarget[i]
        
        arr = rest
        rest = arr.splice(onePageNum)
        
        const onePage = {
          list: arr
        }
        
        if (readingsInTargetChart) {
          const { veryLow = {}, veryhigh = {}, high = {}, low = {}, target = {}} = readingsInTargetChart
          onePage.truePercents = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
          onePage.trueCounts = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
        } else {
          derror(`每七天readingsInTargetChart不存在`, readingsInTargetChart)
          derror(`i: ${i}, sevenDayReadingsInTarget`, sevenDayReadingsInTarget)
        }
        pages.push(onePage)
      }
      
      return pages
    },
    insulinDeliverySetting() {
      const { pdaSetting = {}} = this
      const _map = [`Maxium Basal Rate`, `Base Basal Rate`, `Temporary Basal Rate`, `Bolus Rate`, `Bolus Increment`, `Maxium Bolus`, `Extended Bolus`, `Quick Bolus`, `Quick Bolus Increment`, `Low Reservoir Threshold`]
      const _keys = [`maxiumBasalRate`, `originBasal`, `tempBasalRate`, `bolusRate`, `bolusIncrement`, `maxBolus`, `doubleBolus`, `quickBolus`, `quickBolusIncrement`, `lowReseverThreshold`]
      const columns = _keys.map((k, i) => {
        const label = _map[i]
        const pda = pdaSetting[k]
        return {
          column0: this.$t(label),
          column1: pda ? this.$t(pda) : ''
        }
      })
      
      return columns
    },
    calculatorSettingPages() {
      const onePageMaxRowNums = 20 // 这个数值，要跟@c/BolusCalculatorSettingTable里头的 _onePageRowNumMax变量联动
      const { reverseCorrection, pdaSetting = {}} = this
      const { highBgArray = [], lowBgArray = [], defaultChoArray = [], sensitiveSilverArray = [] } = pdaSetting
      
      // // dev,mock
      // const { highBgArray = [], lowBgArray = [] } = pdaSetting
      // const defaultChoArray = Array.from({ length: 12 }).map((v, i) => {
      //   return {
      //     time: i,
      //     value: '3 g carb/U'
      //   }
      // })
      // const sensitiveSilverArray = Array.from({ length: 16 }).map((v, i) => {
      //   return {
      //     time: i,
      //     value: '3 g carb/U'
      //   }
      // })
      // // End dev,mock
      const bgTmpObj = {}
      const { effectiveTime } = pdaSetting
      const extra = { effectiveTime }
      if (![undefined, null, 'null', 'NULL', ''].includes(reverseCorrection)) {
        extra.reverseCorrection = ['true', 'TRUE'].includes(`${reverseCorrection}`.trim())
      }
      
      highBgArray.forEach(bg => {
        const { time, value } = bg
        const k = `${time}`.trim()
        let inObj = bgTmpObj[k]
        
        if (!inObj) {
          inObj = bgTmpObj[k] = {}
        }
        inObj['high'] = value
      })
      lowBgArray.forEach(bg => {
        const { time, value } = bg
        const k = `${time}`.trim()
        let inObj = bgTmpObj[k]
        
        if (!inObj) {
          inObj = bgTmpObj[k] = {}
        }
        inObj['low'] = value
      })
      
      // // dev, mock
      // const bgArray = Array.from({ length: 38 }).map((v, i) => {
      //   return {
      //     time: i,
      //     value: '3 g carb/U'
      //   }
      // })
      // // end dev, mock
      const bgArray = (Object.keys(bgTmpObj)).map(time => {
        return {
          time,
          value: bgTmpObj[`${time}`.trim()]
        }
      })
      
      const hlength = highBgArray.length
      const llength = lowBgArray.length
      const clength = defaultChoArray.length // carboList
      const slength = sensitiveSilverArray.length // sensitivityList
      const bgLength = bgArray.length
      const rowsTotal = bgLength + clength + slength
      
      const tooMuchMustNewPageLimit = onePageMaxRowNums
      
      const columnNum = 1 // 一行显示{columnNum}列
      
      const pagesNumNeeded = Math.ceil((rowsTotal / columnNum) / onePageMaxRowNums) // 这里会有一些临界情况，譬如当bgLength > tooMuchMustNewPageLimit && rowsTotal === onePageMaxRowNums - 1时候，此时这个值算成1,但实际上是需要2页。但由于这个临界情况太多太复杂了，同时本身onePageMaxRowNums这个行数，页面其实还有冗余的，所以我就不考虑这些临界情况了。并且下面渲染pagesNumNeeded页面的逻辑也写的粗糙一点，如果有临界情况就让它异常好了(应该出现概率比较小，因为用户不太会出现临界情况的数据)     
      
      const carboList = defaultChoArray.map(obj => {
        const rst = {
          isCarbo: true,
          column0: obj.time,
          column1: obj.value
        }
        let unit
        let num
        const v = obj.value
        if (/([\d\.]+)([^\d]+$)/.test(v)) {
          unit = (RegExp.$2).trim()
          num = RegExp.$1
          rst.column1 = num
        }
        rst.unitStr = unit
        return rst
      })
      const sensitivityList = sensitiveSilverArray.map(obj => {
        const rst = {
          column0: obj.time,
          column1: obj.value
        }
        let unit
        let num
        const v = obj.value
        if (/([\d\.]+)([^\d]+$)/.test(v)) {
          unit = (RegExp.$2).trim()
          num = RegExp.$1
          rst.column1 = num
        }
        rst.unitStr = unit
        rst.isSensitivity = true
        return rst
      })
      const bgList = bgArray.map(obj => {
        const { time, value } = obj
        const { low, high } = value
        let lownum = low
        let highnum = high
        let unit
        if (/([\d\.]+)([^\d]+$)/.test(low)) {
          lownum = RegExp.$1
          unit = RegExp.$2
        }
        if (/([\d\.]+)([^\d]+$)/.test(high)) {
          highnum = RegExp.$1
          unit = RegExp.$2
        }
        const unitStr = (unit === undefined) ? '' : `${unit}`.trim()
        const rst = {
          isBg: true,
          column0: time,
          column1: `${this.$t('Lower')}: ${lownum};${this.$t('Higher')}: ${highnum}`,
          unitStr
        }
        return rst        
      })
      
      const bgRowNums0 = Math.ceil(bgLength / columnNum)
      const carboRowNums0 = Math.ceil(clength / columnNum)
      const sensitivityRowNums0 = Math.ceil(slength / columnNum)
      
      const onePageRowNum = tooMuchMustNewPageLimit
      const _bgLists = (_groupArrays(bgList, tooMuchMustNewPageLimit * columnNum)).filter(arr => arr.length)
      const _carboLists = (_groupArrays(carboList, tooMuchMustNewPageLimit * columnNum)).filter(arr => arr.length)
      const _sensitivityLists = (_groupArrays(sensitivityList, tooMuchMustNewPageLimit * columnNum)).filter(arr => arr.length)
      
      const _allLists = (_groupArrays([...bgList, ...carboList, ...sensitivityList], tooMuchMustNewPageLimit * columnNum))
      
      const _bgPageNums = _bgLists.length
      const _carboPageNums = _carboLists.length
      
      do {
        const rst = _allLists.map((onePageList = [], index) => {
          const lists = (onePageList.slice()).map(obj => qcopy(obj))
          const bgList = []
          const carboList = []
          const sensitivityList = []
          
          const bgCounts = lists.reduce((prev, cur) => {
            if (cur && cur.isBg) {
              bgList.push(cur)
              return (+prev + 1)
            } else {
              return +prev
            }
          }, 0)
          const carboCounts = lists.reduce((prev, cur) => {
            if (cur && cur.isCarbo) {
              carboList.push(cur)
              return (+prev + 1)
            } else {
              return +prev
            }
          }, 0)
          const sensitivityCounts = lists.reduce((prev, cur) => {
            if (cur && cur.isSensitivity) {
              sensitivityList.push(cur)
              return (+prev + 1)
            } else {
              return +prev
            }
          }, 0)
          
          const rst = {
            extra,
            bgRowNums: bgCounts,
            bgList,
            carboRowNums: carboCounts,
            carboList,            
            sensitivityRowNums: sensitivityCounts,
            sensitivityList
          }
          
          return rst          
        })

        const trueRst = rst.filter(obj => {
          return obj && (obj.carboRowNums + obj.sensitivityRowNums + obj.bgRowNums > 0)
        })
        return trueRst
        /* eslint-disable-next-line*/
      } while (false)
    },
    alarmRecordPages() {
      const { warmMsg = [], alarmRecordRowNumsMax } = this
      const alllist1 = []
      
      const pages = []
      
      warmMsg.forEach(day => {
        const { date, list = [] } = day
        if (list && list.length) {
          const copy = list.map(obj => qcopy(obj))

          // // test,dev,mock: 插入假数据
          // Array.from({ length: 12 }).forEach(v => {
          //   alllist1.push(...copy)            
          // })
          // // End test,dev,mock
          
          alllist1.push(...copy)
        }
        // const tmp = _groupArrays(list, alarmRecordRowNumsMax)
        
        // if (tmp.length) {
        //   tmp.forEach(arr => {
        //     if (arr && arr.length) {
        //       _alllist.push(...arr)
        //     }
        //   })
        // }
      })
            
      const alllist = [...alllist1].sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const groupByDay = {}
      alllist.forEach(obj => {
        const { dateTimeStr } = obj
        if (dateTimeStr) {
          const f = 'YYYY-MM-DD'
          const date = dayjs(dateTimeStr).format(f)
          if (!groupByDay[date]) {
            groupByDay[date] = []
          }
          
          groupByDay[date].push(qcopy(obj))
        }
      })
      
      const days = Object.keys(groupByDay)
      const columns = []
      
      for (let i = 0; i < days.length; i++) {
        const date = days[i]
        const list = groupByDay[date]
        const cs = (_groupArrays(list, alarmRecordRowNumsMax).filter(arr => arr.length)) // 过滤掉空列
        columns.push(...cs)
      }
      
      const l = columns.length
      const onePageColNum = 3
      const onePageRowNum = 2
      const onePageGroupNums = onePageColNum * onePageRowNum
      const pageNum = Math.ceil(l / onePageGroupNums) // 一页3列,一页两行; 使用flex布局而不是grid，是flex兼容性更好
      
      for (let i = 0; i < pageNum; i++) {
        const onePage = []
        const f = 'YYYY-MM-DD'
        
        for (let j = 0; j < onePageGroupNums; j++) {
          const columnsI = i * onePageGroupNums + j
          if (j === 0) {
            // 每一页第一个
            const table = columns[columnsI]
            const tableDate = dayjs(table[0]['dateTimeStr']).format(f)
            onePage.push({
              date: tableDate,
              list: table
            })
          } else {
            const p = {}
            const table = columns[columnsI]
            if (!table || !table.length) {
              // flex布局，所以需要一个占位(opacity:0来占位)
              p.isEmpty = true
              p.list = []
              p.date = ''
            } else {
              const tableDate = dayjs(table[0]['dateTimeStr']).format(f)
              p.date = tableDate
              p.list = table
            }
            onePage.push(p)
          }
        }
        
        pages.push(onePage)
      }
      
      return pages
    },
    timeChangeRecordPages() {
      const { timeChangeRecordList = [], alarmRecordRowNumsMax } = this
      const pages = []
      
      const alllist2 = timeChangeRecordList.map(obj => { // 时间修改记录
        const isTimeChangeRecord = _otherDataGetPumpClockFilter(obj)
        const isTimeZoneChangeRecord = _otherDataGetTimeZoneFilter(obj)
        const rst = {
          ...qcopy(obj)
        }
        if (isTimeChangeRecord) {
          rst['isTimeChangeRecord'] = true
          rst['isTimeZoneChangeRecord'] = isTimeZoneChangeRecord
        }
        return rst
      })
      
      const alllist = [...alllist2].sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面

      const groupByDay = {}
      alllist.forEach(obj => {
        const { dateTimeStr } = obj
        if (dateTimeStr) {
          const f = 'YYYY-MM-DD'
          const date = dayjs(dateTimeStr).format(f)
          if (!groupByDay[date]) {
            groupByDay[date] = []
          }
          
          groupByDay[date].push(qcopy(obj))
        }
      })
      
      const days = Object.keys(groupByDay)
      const columns = []
      
      for (let i = 0; i < days.length; i++) {
        const date = days[i]
        const list = groupByDay[date]
        const cs = (_groupArrays(list, alarmRecordRowNumsMax).filter(arr => arr.length)) // 过滤掉空列
        columns.push(...cs)
      }
      
      const l = columns.length
      const onePageColNum = 3
      const onePageRowNum = 2
      const onePageGroupNums = onePageColNum * onePageRowNum
      const pageNum = Math.ceil(l / onePageGroupNums) // 一页3列,一页两行; 使用flex布局而不是grid，是flex兼容性更好
      
      for (let i = 0; i < pageNum; i++) {
        const onePage = []
        const f = 'YYYY-MM-DD'
        
        for (let j = 0; j < onePageGroupNums; j++) {
          const columnsI = i * onePageGroupNums + j
          if (j === 0) {
            // 每一页第一个
            const table = columns[columnsI]
            const tableDate = dayjs(table[0]['dateTimeStr']).format(f)
            onePage.push({
              date: tableDate,
              list: table
            })
          } else {
            const p = {}
            const table = columns[columnsI]
            if (!table || !table.length) {
              // flex布局，所以需要一个占位(opacity:0来占位)
              p.isEmpty = true
              p.list = []
              p.date = ''
            } else {
              const tableDate = dayjs(table[0]['dateTimeStr']).format(f)
              p.date = tableDate
              p.list = table
            }
            onePage.push(p)
          }
        }
        
        pages.push(onePage)
      }
      
      return pages
    },
    sortedBasalRateBaseSetting() {
      const { basalRateBaseSetting = [] } = this
      const rst = basalRateBaseSetting.slice()
      rst.sort((first, second) => first.settingIndex - second.settingIndex) // 升序, settingIndex小的在数组前面
      return rst
    },
    activeBasalRateBase() {
      const { sortedBasalRateBaseSetting = [] } = this
      const actives = sortedBasalRateBaseSetting.filter(o => `${o.isActive}`.trim() === '0') // isActive是0，意味着是active的
      const hasActive = actives.length
      if (!hasActive) {
        return {}
      } else {
        return actives[0]
      }
    },
    basalRateBase1() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 1)
    },
    basalRateBase1Name() {
      return _f2.call(this, 1)
    },
    basalRateBase1TableData() {
      return _f3.call(this, 1)
    },
    basalRateBase1TableDataLarger4Columns() {
      return _f4.call(this, 1)
    },
    basalRateBase1TableDataLarger6Columns() {
      return _f5.call(this, 1)
    },
    basalRateBase1TableDataLarger8Columns() {
      return _f6.call(this, 1)
    },
    basalRateBase1TotalDose() {
      return _f7.call(this, 1)
    },
    basalRateBase2() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 2)
    },
    basalRateBase2Name() {
      return _f2.call(this, 2)
    },
    basalRateBase2TableData() {
      return _f3.call(this, 2)
    },
    basalRateBase2TableDataLarger4Columns() {
      return _f4.call(this, 2)
    },
    basalRateBase2TableDataLarger6Columns() {
      return _f5.call(this, 2)
    },
    basalRateBase2TableDataLarger8Columns() {
      return _f6.call(this, 2)
    },
    basalRateBase2TotalDose() {
      return _f7.call(this, 2)
    },
    basalRateBase3() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 3)
    },
    basalRateBase3Name() {
      return _f2.call(this, 3)
    },
    basalRateBase3TableData() {
      return _f3.call(this, 3)
    },
    basalRateBase3TableDataLarger4Columns() {
      return _f4.call(this, 3)
    },
    basalRateBase3TableDataLarger6Columns() {
      return _f5.call(this, 3)
    },
    basalRateBase3TableDataLarger8Columns() {
      return _f6.call(this, 3)
    },
    basalRateBase3TotalDose() {
      return _f7.call(this, 3)
    },
    basalRateBase4() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 4)
    },
    basalRateBase4Name() {
      return _f2.call(this, 4)
    },
    basalRateBase4TableData() {
      return _f3.call(this, 4)
    },
    basalRateBase4TableDataLarger4Columns() {
      return _f4.call(this, 4)
    },
    basalRateBase4TableDataLarger6Columns() {
      return _f5.call(this, 4)
    },
    basalRateBase4TableDataLarger8Columns() {
      return _f6.call(this, 4)
    },
    basalRateBase4TotalDose() {
      return _f7.call(this, 4)
    },
    basalRateBase5() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 5)
    },
    basalRateBase5Name() {
      return _f2.call(this, 5)
    },
    basalRateBase5TableData() {
      return _f3.call(this, 5)
    },
    basalRateBase5TableDataLarger4Columns() {
      return _f4.call(this, 5)
    },
    basalRateBase5TableDataLarger6Columns() {
      return _f5.call(this, 5)
    },
    basalRateBase5TableDataLarger8Columns() {
      return _f6.call(this, 5)
    },
    basalRateBase5TotalDose() {
      return _f7.call(this, 5)
    },
    basalRateBase6() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 6)
    },
    basalRateBase6Name() {
      return _f2.call(this, 6)
    },
    basalRateBase6TableData() {
      return _f3.call(this, 6)
    },
    basalRateBase6TableDataLarger4Columns() {
      return _f4.call(this, 6)
    },
    basalRateBase6TableDataLarger6Columns() {
      return _f5.call(this, 6)
    },
    basalRateBase6TableDataLarger8Columns() {
      return _f6.call(this, 6)
    },
    basalRateBase6TotalDose() {
      return _f7.call(this, 6)
    },
    basalRateBase7() {
      const { sortedBasalRateBaseSetting = [] } = this
      return _f1.call(this, 7)
    },
    basalRateBase7Name() {
      return _f2.call(this, 7)
    },
    basalRateBase7TableData() {
      return _f3.call(this, 7)
    },
    basalRateBase7TableDataLarger4Columns() {
      return _f4.call(this, 7)
    },
    basalRateBase7TableDataLarger6Columns() {
      return _f5.call(this, 7)
    },
    basalRateBase7TableDataLarger8Columns() {
      return _f6.call(this, 7)
    },
    basalRateBase7TotalDose() {
      return _f7.call(this, 7)
    },
  },
  mounted() {
  },
  beforeDestroy() {
  }
}
